import { Button, Modal } from 'react-bootstrap';
import Cookie from "cookie-universal";
import { useNavigate} from "react-router-dom";
import { useState } from 'react';
import Loading from '../../../Components/Loading/Loading';
export default function CartNav(props) {
     //Navigate
    const Navigate=useNavigate();
    //cookie
     const cookie = Cookie();
     const token=cookie.get("e-commerce"); 

    const handleClose = props.handleClose;
    const handleNext = () =>{props.changeShow(false);
      Navigate('/order' , {replace:true});}

    return(<>
           {props.loading && <Loading/>}
           <Modal  show={props.show} onHide={handleClose}>
                 <Modal.Header closeButton>
                   <Modal.Title style={{color:'var(--primaryColor)'}}>{props.title}</Modal.Title>
                 </Modal.Header>
                 <Modal.Body className='parent-cart text-center p-2 pb-0'
                 style={{borderBlock:'2px solid var(--primaryColor)'}}> { props.data.length===0?<span className='text-black-50'>{`Your ${props.description} is empty`}</span>:props.data}</Modal.Body>
                 <Modal.Footer>
                   <Button variant="secondary" onClick={handleClose}>
                     Close
                   </Button>
                   {props.showBtn && <Button variant="primary" disabled={props.data.length === 0?true:false} onClick={handleNext}>
                     Next
                   </Button>}
                 </Modal.Footer>
               </Modal>
               </>
               
    );

}
